<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="TOKEN：" prop="token">
                <span>{{model.token}}</span>
            </el-form-item>
            <el-form-item label="验证码：" prop="yzm">
                <span>{{model.yzm}}</span>
            </el-form-item>
            <el-form-item label="VID：" prop="vid">
                <span>{{model.vid}}</span>
            </el-form-item>
            <el-form-item label="会员ID：" prop="member_id">
                <span>{{model.member_id}}</span>
            </el-form-item>
            <el-form-item label="充值号：" prop="recharge_sn">
                <span>{{model.recharge_sn}}</span>
            </el-form-item>
            <el-form-item label="备注：" prop="remark">
                <span>{{model.remark}}</span>
            </el-form-item>
            <!-- <el-form-item label="车辆ID：" prop="member_id">
                <span>{{model.car_info_id}}</span>
            </el-form-item> -->
            <!-- <el-form-item label="状态：" prop="state">
                <span>{{model.state}}</span>
            </el-form-item> -->
            <el-form-item label="添加时间：" prop="add_time">
                <span>{{model.add_time}}</span>
            </el-form-item>
            <el-form-item label="绑定时间：" prop="bind_time">
                <span>{{model.bind_time}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'mdhzInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                token: '',
                vid: '',
                member_id: '',
                state: '',
                add_time: '',
                bind_time: '',
            },
            getObj:{
                url:'/api/admin/mdhz/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>